var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.assessPlan.processes, function (process, idx) {
      return _c("div", { key: idx, staticClass: "riskSheet q-mb-lg" }, [
        _c("div", { staticClass: "processBigTitle" }, [
          _vm._v(
            " [" +
              _vm._s(process.assessDeptName) +
              "] " +
              _vm._s(process.processName) +
              " "
          ),
        ]),
        _c("table", { staticClass: "headerTable" }, [
          _vm._m(0, true),
          _c("tbody", [
            _c("tr", [
              _c("th", { staticClass: "hLabel" }, [_vm._v("팀명(반)")]),
              _c("td", { staticClass: "hValue" }, [
                _vm._v(_vm._s(process.assessDeptName)),
              ]),
              _c("td", { staticClass: "mainTitle", attrs: { rowspan: "3" } }, [
                _vm._v("안전보건상 위험정보"),
              ]),
              _c("th", { staticClass: "hLabel" }, [_vm._v("근로자수")]),
              _c("td", { staticClass: "hValue" }, [
                _vm._v(_vm._s(process.workerCnt) + "명"),
              ]),
            ]),
            _c("tr", [
              _c("th", { staticClass: "hLabel" }, [_vm._v("공정명")]),
              _c("td", { staticClass: "hValue" }, [
                _vm._v(_vm._s(process.processName)),
              ]),
              _c("th", { staticClass: "hLabel" }, [_vm._v("생산품(기종)")]),
              _c("td", { staticClass: "hValue" }, [
                _vm._v(_vm._s(process.productName)),
              ]),
            ]),
            _c("tr", [
              _c("th", { staticClass: "hLabel" }, [_vm._v("원(재)료")]),
              _c("td", { staticClass: "hValue" }, [
                _vm._v(_vm._s(process.mainMaterial)),
              ]),
              _c("th", { staticClass: "hLabel" }),
              _c("td", { staticClass: "hValue" }),
            ]),
          ]),
        ]),
        _c("table", { staticClass: "riskTable" }, [
          _vm._m(1, true),
          _vm._m(2, true),
          _c(
            "tbody",
            [
              _vm._l(process._rows, function (row, rIdx) {
                return [
                  _c("tr", { key: idx + "_" + rIdx }, [
                    row.isFirstWorkRow
                      ? _c(
                          "td",
                          {
                            staticClass: "cLeft",
                            attrs: { rowspan: row.workRowSpan },
                          },
                          [_vm._v(" " + _vm._s(row.unitWorkName) + " ")]
                        )
                      : _vm._e(),
                    _c("td", { staticClass: "cLeft" }, [
                      _vm._v(_vm._s(row.equipName)),
                    ]),
                    _c("td", { staticClass: "cCenter" }, [
                      _vm._v(_vm._s(row.equipQty)),
                    ]),
                    _c("td", { staticClass: "cLeft" }, [
                      _vm._v(_vm._s(row.chemName)),
                    ]),
                    _c("td", { staticClass: "cCenter" }, [
                      _vm._v(_vm._s(row.chemQty)),
                    ]),
                    _c("td", { staticClass: "cCenter" }, [
                      _vm._v(_vm._s(row.chemTime)),
                    ]),
                    rIdx === 0
                      ? _c(
                          "td",
                          {
                            staticClass: "etcInfoCell",
                            attrs: { rowspan: process._rows.length },
                          },
                          [
                            _c("div", { staticClass: "etcRow" }, [
                              _vm._v(
                                " ◈ 최근 3년간 재해발생사례 : " +
                                  _vm._s(
                                    _vm.getAccidentNames(
                                      process.accidentHistoryDesc
                                    )
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("div", { staticClass: "etcRow" }, [
                              _vm._v(
                                " ◈ 아차사고사례 : " +
                                  _vm._s(
                                    _vm.getAccidentNames(process.nearMissDesc)
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("div", { staticClass: "etcRow" }, [
                              _vm._v("◈ 근로자 구성 및 경력특성"),
                            ]),
                            _c(
                              "div",
                              { staticClass: "chipGrid" },
                              _vm._l(_vm.workerTypeItems, function (citem) {
                                return _c(
                                  "span",
                                  {
                                    key: citem.code,
                                    staticClass: "chip",
                                    class: {
                                      chipOn: _vm.isSelected(
                                        process.workerTypeCd,
                                        citem.code
                                      ),
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(citem.codeName) + " ")]
                                )
                              }),
                              0
                            ),
                            _c("div", { staticClass: "etcRow" }, [
                              _vm._v(" ◈ 교대작업유무 : "),
                              _c(
                                "span",
                                {
                                  staticClass: "chip",
                                  class: { chipOn: process.shiftFlag === "Y" },
                                },
                                [_vm._v("유")]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "chip",
                                  class: { chipOn: process.shiftFlag !== "Y" },
                                },
                                [_vm._v("무")]
                              ),
                            ]),
                            _c(
                              "div",
                              { staticClass: "etcRow" },
                              [
                                _vm._v(" ◈ 중량물 운반수단 : "),
                                _vm._l(
                                  _vm.transportTypeItems,
                                  function (citem) {
                                    return _c(
                                      "span",
                                      {
                                        key: citem.code,
                                        staticClass: "chip",
                                        class: {
                                          chipOn: _vm.isSelected(
                                            process.heavyTransportTypeCd,
                                            citem.code
                                          ),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(citem.codeName) + " "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                            _c("div", { staticClass: "etcRow etcSub" }, [
                              _vm._v(
                                " ▶ 장비명 : " +
                                  _vm._s(process.heavyTransportEquip) +
                                  " "
                              ),
                            ]),
                            _c("div", { staticClass: "etcRow" }, [
                              _vm._v(" ◈ 중량물 인력취급유무 : "),
                              _c(
                                "span",
                                {
                                  staticClass: "chip",
                                  class: {
                                    chipOn: process.heavyManualFlag === "Y",
                                  },
                                },
                                [_vm._v("유")]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "chip",
                                  class: {
                                    chipOn: process.heavyManualFlag !== "Y",
                                  },
                                },
                                [_vm._v("무")]
                              ),
                            ]),
                            _c(
                              "div",
                              { staticClass: "etcRow etcSub" },
                              [
                                _vm._v(" ▶ 취급형태 : "),
                                _vm._l(_vm.handlingTypeItems, function (citem) {
                                  return _c(
                                    "span",
                                    {
                                      key: citem.code,
                                      staticClass: "chip",
                                      class: {
                                        chipOn: _vm.isSelected(
                                          process.heavyManualTypeCd,
                                          citem.code
                                        ),
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(citem.codeName) + " ")]
                                  )
                                }),
                              ],
                              2
                            ),
                            _c("div", { staticClass: "etcRow" }, [
                              _vm._v(" ◈ 작업환경측정 실시 : "),
                              _c(
                                "span",
                                {
                                  staticClass: "chip",
                                  class: {
                                    chipOn: process.workEnvMeasureFlag === "Y",
                                  },
                                },
                                [_vm._v("유")]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "chip",
                                  class: {
                                    chipOn: process.workEnvMeasureFlag !== "Y",
                                  },
                                },
                                [_vm._v("무")]
                              ),
                            ]),
                            _c("div", { staticClass: "etcRow etcSub" }, [
                              _vm._v(
                                " ▶ 노출초과인자/수치 : " +
                                  _vm._s(process.exposureOverValue) +
                                  " "
                              ),
                            ]),
                            _c("div", { staticClass: "etcRow" }, [
                              _vm._v("◈ 특별안전보건교육 해당"),
                            ]),
                            _c(
                              "div",
                              { staticClass: "chipGrid" },
                              _vm._l(_vm.specialEduItems, function (citem) {
                                return _c(
                                  "span",
                                  {
                                    key: citem.code,
                                    staticClass: "chip",
                                    class: {
                                      chipOn: _vm.isSelected(
                                        process.specialEduTargetCd,
                                        citem.code
                                      ),
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(citem.codeName) + " ")]
                                )
                              }),
                              0
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]
              }),
            ],
            2
          ),
        ]),
      ])
    }),
    0
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { staticStyle: { width: "90px" } }),
      _c("col", { staticStyle: { width: "200px" } }),
      _c("col"),
      _c("col", { staticStyle: { width: "90px" } }),
      _c("col", { staticStyle: { width: "200px" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { staticStyle: { width: "150px" } }),
      _c("col", { staticStyle: { width: "150px" } }),
      _c("col", { staticStyle: { width: "60px" } }),
      _c("col", { staticStyle: { width: "120px" } }),
      _c("col", { staticStyle: { width: "80px" } }),
      _c("col", { staticStyle: { width: "80px" } }),
      _c("col", { staticStyle: { width: "450px" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "tHead", attrs: { rowspan: "2" } }, [
          _vm._v("단위작업(순서)"),
        ]),
        _c("th", { staticClass: "tHead", attrs: { colspan: "2" } }, [
          _vm._v("기계,기구 및 설비"),
        ]),
        _c("th", { staticClass: "tHead", attrs: { colspan: "3" } }, [
          _vm._v("유해화학물질"),
        ]),
        _c("th", { staticClass: "tHead", attrs: { rowspan: "2" } }, [
          _vm._v("기타 안전보건상 정보"),
        ]),
      ]),
      _c("tr", [
        _c("th", { staticClass: "tSubHead" }, [_vm._v("기계,기구 및 설비 명")]),
        _c("th", { staticClass: "tSubHead" }, [_vm._v("수량")]),
        _c("th", { staticClass: "tSubHead" }, [_vm._v("화학물질명")]),
        _c("th", { staticClass: "tSubHead" }, [_vm._v("일 취급량")]),
        _c("th", { staticClass: "tSubHead" }, [_vm._v("취급시간")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }